// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--1yE-i","heading":"index-module--heading--3Y68W","customMedia":{},"customProperties":{},"customSelectors":{}};